import React, { useState, useEffect } from "react"
import { Services } from "./services"
import { Serviceregions } from "./serviceregions"
import { Associaion_Certification } from "./association-certification"
import { useClickOutside } from "../../utils/hooks/useClickOutside"
import { ContactForm } from "../contact-form/contact-form"
import "../../assets/scss/styles.scss"
import location from "../../assets/img/pin.png"
import close from "../../assets/img/plus-circle.png"


export const ContactModal = ({requestedContractor, setShowModal, setOverlay, user}) => {
    const [servesArea, setServesArea] = useState(false)

    useEffect(()=>{
        const checkServesArea = () => {
            if (requestedContractor.contractor.districts_served_value.includes(user.district))
            setServesArea(true)
        }

        if (user) {
            checkServesArea()
        } else {
            setServesArea(false)
        }
    }, [user])

    // remove the service tags with empty values, pass this as a prop to <Service/> and <ContactForm/>
    const serviceFields = [
        requestedContractor.contractor.ppn_primary_specialty,
        requestedContractor.contractor.ppn_secondary_specialty,
        requestedContractor.contractor.ppn_tertiary_specialty,
        requestedContractor.contractor.ppn_quaternary_specialty
    ].filter((x) => !!x)

    const closeDialog = () => {
		let body = document.body;
		let scrollY = body.style.top;
		body.style.position = '';
		body.style.top = '';
		body.style.width = '';
		body.style.paddingRight = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	};

    // use the hook to handle the outside click
    const domNode = useClickOutside(() => {
        setOverlay(false)
        setShowModal(false)
        closeDialog()
    })

    return (
        <div className="contact-modal-container" ref={domNode}>
            <div className="fac-contact-modal">
                <div className="contractor-row contractor-card-name">
                    <h2 className="contractor-card-title fac-modal-title">
                    {requestedContractor.contractor.company_name}
                    </h2>
                    <button className="contact-modal-x" onClick={() => {
                        setShowModal(false)
                        setOverlay(false)
                        closeDialog()
                    }}>
                        <img src={close}/>
                    </button>
                </div>

                <div className="contractor-row contractor-card-details">
                    <div className="contractor-card-location">
                        <img src={location} alt="location icon" className="icon locations-icon" />
                        <p className="contractor-city">{requestedContractor.contractor.address1_city},</p>
                        <p className="contractor-state">&nbsp;{requestedContractor.contractor.address1_state}</p>
                    </div>
                    <div className="contractor-card-projects contractor-card-projects-modal">
                        {servesArea === true &&
                            <ul className="vendorServesArea"><li>Vendor HQ is located outside of your location but will serve your region</li></ul>
                        }
                    </div>
                </div>

                <div className="contractor-information-container">
                    <div className="contractor-info-cell">
                        <Services serviceFields={serviceFields} />
                    </div>
                    <div className="contractor-info-cell">
                        <Serviceregions requestedContractor={requestedContractor} />
                    </div>
                    <div className="contractor-info-cell">
                        <Associaion_Certification requestedContractor={requestedContractor} />
                    </div>
                </div>

                 {(requestedContractor.contractor.certification==="SILVER")? '' :
                 <ContactForm setShowModal={setShowModal} setOverlay={setOverlay} serviceFields={serviceFields} requestedContractor={requestedContractor} />}
            </div>
        </div>
    )
}
